<div class="p-2">
  <form *ngIf="status === CreateClientConnectionStatus.TOKEN" [formGroup]="form" class="wizard__forms">
    <p>{{'lang.clientManagement.connection.create.token.infoText' | translate}}</p>

    <div class="form-group validateMe">
      <label class="form-label" for="Token">{{'lang.clientManagement.connection.create.token' | translate}}</label>
      <input type="text" id="Token" class="form-control" formControlName="Token">
      <div *ngIf="Token.touched && Token.errors?.required" class="alert alert-danger">
        {{'lang.clientManagement.connection.create.tokenWarning' | translate}}</div>
      <div *ngIf="Token.errors?.notFoundError" class="alert alert-danger position-relative">
        {{'lang.clientManagement.connection.create.tokenNotFoundWarning' | translate}}
      </div>
    </div>
  </form>

  <div *ngIf="status === CreateClientConnectionStatus.CHECK">
    <p>{{'lang.clientManagement.connection.create.check.infoText' | translate}}</p>

    <div class="client mt-2 mb-2">
      <img *ngIf="client?.logo?.url" class="client-image" [src]="client.logo.url" alt="logo">
      <div class="client-infos">
        <span class="client-name">{{client.name}}</span>
        <span *ngIf="clientAddress" class="client-address">{{clientAddress}}</span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="status === CreateClientConnectionStatus.REQUEST_SEND">
    <div *ngIf="!errorMessage" class="connection-result">
      <sb-icon
          icon="successAnimation"
          class="green"
          [animationOptions]="{autoplay: true}">
      </sb-icon>
      <div class="connection-result-infos">
                <span class="connection-result-headline green">{{'lang.clientManagement.connection.create.requestSend' |
                    translate}}</span>
      </div>
    </div>

    <div *ngIf="errorMessage" class="connection-result">
      <sb-icon
          icon="errorAnimation"
          class="red"
          [animationOptions]="{autoplay: true}">
      </sb-icon>
      <div class="connection-result-infos">
                <span class="connection-result-headline red">{{'lang.clientManagement.connection.create.requestNotSend' |
                    translate}}</span>
        <span class="red">{{errorMessage}}</span>
      </div>
    </div>
  </ng-container>


  <div class="d-flex justify-content-between w-full mt-4">
    <sb-button
        *ngIf="!openedWithDefaultToken && status > CreateClientConnectionStatus.TOKEN && status <
                CreateClientConnectionStatus.REQUEST_SEND"
        classes="btn-secondary btn-sm"
        (submitClicked)="previous()">
      {{'lang.globals.previous' | translate}}
    </sb-button>
    <sb-button *ngIf="status == CreateClientConnectionStatus.TOKEN" [disabled]="!form.valid"
               classes="btn-primary btn-sm" style="margin-left: auto;"
               (submitClicked)="next()">
      {{'lang.globals.next' | translate}}
    </sb-button>
    <sb-button *ngIf="status == CreateClientConnectionStatus.CHECK"
               classes="btn-primary btn-sm" [style]="'margin-left: auto; ' +
                   (openedWithDefaultToken ? 'margin-right: auto;' : '') " (submitClicked)="next()">
      <sb-icon icon="send"></sb-icon>&nbsp;<span
        class="d-none d-sm-inline-block">{{'lang.clientManagement.connection.create.check.sendRequest' | translate}}</span>
    </sb-button>
    <sb-button *ngIf="status == CreateClientConnectionStatus.REQUEST_SEND"
               classes="btn-primary btn-sm" style="margin-left: auto; margin-right: auto;"
               (submitClicked)="next()">
      <span>{{'lang.globals.done' | translate}}</span>
    </sb-button>
  </div>
</div>

